<div class="content" style="height: 750px; width: 100%">
<!--  <a target="_blank" href="https://marketplace.chemsec.org/alternatives?groups=5"> -->
    <div style="z-index: -1; height: 100%; width: 100%; position: static;">
      <iframe src="https://marketplace.chemsec.org/alternatives?groups=5" height="100%" width="100%" style="z-index: 100; position: relative;"></iframe>
    </div>
<!--  </a> -->
</div>
